<template>
  <div
    class="dialog-mask animated fadeIn dialog-agenda-mask" v-if="showModal"
  >
    <div class="dialog-content" :style="{ top: scrollTop + clientHeight / 2  + 'px' }">
      <div class="zgzb-dialog">
        <div class="zgzb-d1">
          {{ meetDetail['name' + En] }}
        </div>
        <img class="zgzb-d2" :src="meetDetail.coverImgUrl" alt="">
        <div class="zgzb-d3 vhtml" v-html="isPc ? meetDetail['pcTreasureContent' + En] : meetDetail['mobileTreasureContent' + En]">
        </div>
      </div>
      <div class="dialog-close" @click="closeMeetModal">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/forum-close.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import protal from "@/api/protal"
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: String,
    },
  },
  data() {
    return {
      forumTime: "",
      forumLocation: "",
      forumOrganization: "",
      speakersGuest: "",
      forumnIntro: "",
      meetDetail:{}
    };
  },
  computed: {
    orgs() {
      return this.meetDetail.forumOrgStructureReqs && this.meetDetail.forumOrgStructureReqs.filter(x => x.type == 1).map(x => x['name' + this.En]).join('；')
    },
  },
  methods: {
    closeMeetModal() {
      this.$emit("update:showModal", false)
      this.$emit("closeMeetModal");
    },
    getDetail(){
      protal.queryTreasureZhenGuan(this.uuid).then((res) => {
        if (res && res.data) {
          this.meetDetail = res.data;
          if (this.meetDetail.forumOrgStructureReqs) {
            this.meetDetail.forumOrgUnit = this.meetDetail.forumOrgStructureReqs
              .map((x) => {
                return x.name;
              })
              .join("、");
            this.meetDetail.forumOrgUnitEn = this.meetDetail.forumOrgStructureReqs
              .map((x) => {
                return x.nameEn;
              })
              .filter((item) => item)
              .join("、");
          }
        }
      });
    }
  },
  watch: {
    uuid: function (newV, oldV) {
      console.log(newV)
      this.uuid = newV;
      this.getDetail();
    },
  },
};
</script>
<style lang='less' scoped>
@media screen and (min-width: 769px) {
  .dialog-mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 3000;
    .dialog-content {
      position: fixed;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      width: 12rem;
      height: 7.6rem;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.9);
      border-radius: .16rem;
      padding: .3rem .6rem .5rem;
    }

    .zgzb-d1 {
      font-size: .26rem;
      color: #33302F;
      font-weight: bold;
      margin-bottom: .2rem;
    }

    .zgzb-d2 {
      display: block;
      width: 100%;
      height: auto;
      margin-bottom: .2rem;
    }
    .ptitle {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: -0.18rem;
        width: .36rem;
        height: .06rem;
        background: url(https://static.worldaic.com.cn/2024/web/static/images/border-bottom.png);
        background-size: 100% 100%;
      }
    }
    .dialog-content-agenda {
      width: 100%;
      height: 100%;
      padding: .32rem .6rem .36rem;
      overflow-y: auto;
      box-sizing: border-box;
      &::-webkit-scrollbar {
        display: none;
        width: 6px;
        height: 100%;
        border-radius: 3px;
        background: #E9E9E9;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: #C8C8C8;
      }
      .info {
        position: relative;
        text-align: left;
        .meeting-title {
          font-size: .28rem;
          margin-bottom: .14rem;
          font-weight: bold;
          color: #3E3A39;
        }
        .info-item {
          display: flex;
          font-size: .18rem;
          line-height: .3rem;
          color: #736B69;
          span {
            display: block;
            flex: 1;
          }
        }
      }
      .line {
        margin-top: .14rem;
        height: 1px;
        background: #D9D9D9;
      }
      .lt-intro {
        margin-top: .28rem;
        text-align: left;
        .meeting-title {
          font-size: .26rem;
          font-weight: bold;
          color: #595757;
          line-height: 1;
        }
        .desc {
          margin-top: .26rem;
          font-size: .18rem;
          line-height: .28rem;
          color: #3E3A39;
        }
      }
      .richeng {
        margin-top: .48rem;

        .meeting-title {
          font-size: .28rem;
          font-weight: bold;
          color: #3E3A39;
          text-align: left;
        }

        .richeng-list {
          margin-top: .38rem;
          position: relative;

          .richeng-item {
            font-size: .18rem;
            color: #736B69;
            display: flex;
            align-items: center;
            line-height: 1;
            margin-bottom: .28rem;
            padding-left: .16rem;
            position: relative;

            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: .08rem;
              height: .08rem;
              border-radius: 50%;
              background: #B3B3B3;
            }

            &::after {
              content: "";
              position: absolute;
              left: .03rem;
              top: .12rem;
              width: .02rem;
              height: .4rem;
              background: #B3B3B3;
            }

            &:last-of-type::after {
              display: none;
            }

            span {
              margin-right: .16rem;
            }

            big {
              font-size: .18rem;
              color: #403C3B;
              font-family: sybold;
            }
          }
        }
      }
      .people-list-wrapper {
        width: 100%;

        .meeting-title {
          font-size: .28rem;
          font-weight: bold;
          color: #3E3A39;
          text-align: left;
        }
        .people-list {
          width: calc(100% + 20px);
          margin-top: .38rem;
          display: flex;
          flex-wrap: wrap;

          .people-item {
            width: 2rem;
            height: 3.5rem;
            border-radius: 1rem;
            background: linear-gradient(175deg, #3099F5 0%, rgba(196, 2, 228, 0.5) 100%);
            margin-right: .2rem;
            cursor: pointer;
            margin-bottom: .4rem;

            &:nth-of-type(5n) {
              margin-right: 0;
            }

            img {
              width: 100%;
              height: 2rem;
              border-radius: 1rem;
              border: .1rem solid rgba(255, 255, 255, .2);
              display: block;
            }

            .text {
              padding: .1rem .28rem 0;

              .big {
                font-size: .24rem;
                color: #fff;
                display: block;
                font-family: sybold;
                margin-bottom: .12rem;
              }

              .small {
                font-size: .18rem;
                line-height: .23rem;
                display: block;
                color: rgba(255, 255, 255, .9);
              }
            }
          }
        }
      }
    }
    .dialog-close {
      position: absolute;
      top: -0.44rem;
      right: -0.44rem;
      width: .54rem;
      height: .54rem;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .dialog-mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 3000;
    .dialog-content {
      position: fixed;
      left: .2rem;
      top: 1.54rem;
      bottom: 2.24rem;
      width: 7.1rem;
      padding: .36rem .28rem .24rem;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.9);
      border-radius: .16rem;

      .zgzb-d1 {
        font-size: .32rem;
        color: #33302F;
        font-weight: bold;
        margin-bottom: .32rem;
      }

      .zgzb-d2 {
        display: block;
        width: 100%;
        height: auto;
        margin-bottom: .32rem;
      }
    }
    .ptitle {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: -0.18rem;
        width: .36rem;
        height: .06rem;
        background: url(https://static.worldaic.com.cn/2024/web/static/images/border-bottom.png);
        background-size: 100% 100%;
      }
    }
    .dialog-content-agenda {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      box-sizing: border-box;
      &::-webkit-scrollbar {
        display: none;
        width: 6px;
        height: 100%;
        border-radius: 3px;
        background: #E9E9E9;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: #C8C8C8;
      }
      .info {
        position: relative;
        text-align: left;
        .meeting-title {
          font-size: .32rem;
          margin-bottom: .14rem;
          font-weight: bold;
          color: #3E3A39;
        }
        .info-item {
          display: flex;
          font-size: .24rem;
          line-height: .4rem;
          color: #736B69;
          span {
            display: block;
            flex: 1;
          }
        }
      }
      .line {
        margin-top: .14rem;
        height: 1px;
        background: #D9D9D9;
      }
      .lt-intro {
        margin-top: .28rem;
        text-align: left;
        .meeting-title {
          font-size: .3rem;
          font-weight: bold;
          color: #595757;
          line-height: 1;
        }
        .desc {
          margin-top: .26rem;
          font-size: .26rem;
          line-height: .38rem;
          color: #3E3A39;
        }
      }
      .richeng {
        margin-top: .48rem;

        .meeting-title {
          font-size: .3rem;
          font-weight: bold;
          color: #3E3A39;
          text-align: left;
        }

        .richeng-list {
          margin-top: .38rem;
          position: relative;

          .richeng-item {
            font-size: .26rem;
            color: #736B69;
            display: flex;
            align-items: center;
            line-height: 1;
            margin-bottom: .24rem;
            padding-left: 12px;
            position: relative;

            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background: #B3B3B3;
            }

            &::after {
              content: "";
              position: absolute;
              left: 2px;
              top: .12rem;
              width: 1px;
              height: .46rem;
              background: #B3B3B3;
            }

            &:last-of-type::after {
              display: none;
            }

            span {
              margin-right: .16rem;
            }

            big {
              font-size: .26rem;
              color: #403C3B;
              font-family: sybold;
              flex: 1;
              overflow: hidden;
            }
          }
        }
      }
      .people-list-wrapper {
        margin-top: .48rem;

        .meeting-title {
          font-size: .3rem;
          font-weight: bold;
          color: #3E3A39;
          text-align: left;
        }
        .people-list {
          margin-top: .38rem;
          display: flex;
          flex-wrap: wrap;

          .people-item {
            width: 2rem;
            height: 3.8rem;
            border-radius: 1rem;
            background: linear-gradient(175deg, #3099F5 0%, rgba(196, 2, 228, 0.5) 100%);
            margin-right: .24rem;
            cursor: pointer;
            margin-bottom: .4rem;

            &:nth-of-type(3n) {
              margin-right: 0;
            }

            img {
              width: 100%;
              height: 2rem;
              border-radius: 1rem;
              border: .1rem solid rgba(255, 255, 255, .2);
              display: block;
            }

            .text {
              padding: .1rem .28rem 0;

              .big {
                font-size: .3rem;
                color: #fff;
                display: block;
                font-family: sybold;
                margin-bottom: .12rem;
              }

              .small {
                font-size: .24rem;
                line-height: .36rem;
                display: block;
                color: rgba(255, 255, 255, .9);
              }
            }
          }
        }
      }
    }
    .dialog-close {
      position: absolute;
      bottom: -1.04rem;
      left: 50%;
      transform: translateX(-50%);
      width: .8rem;
      height: .8rem;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/zgzbDialog.vue